import {Injectable} from '@angular/core';
import {PatientRestApiService} from '../http/patient-rest-api.service';
import {ActivatedRouteSnapshot} from '@angular/router';
import {map, mergeMap, Observable, tap} from 'rxjs';
import {Utils} from '@astek/utils';
import {ApiPatientResponse} from '../http/api-patient-response';
import {PatientData} from '../data/patient-data';
import {ApiFileResponse} from '../http/api-file-response';
import {PatientRouteParamsEnum} from '../navigation/patient-route-params.enum';
import {PatientDataParserService} from '../data/patient-data-parser.service';
import {ApiAlgoResultsResponse} from '../http/api-algo-results-response';

@Injectable()
export class PatientResolver {

  constructor(
    private readonly _patientRestApiService: PatientRestApiService,
    private readonly _patientDataParserService: PatientDataParserService,
  ) {
  }

  public resolve(route: ActivatedRouteSnapshot): Observable<PatientData> {
    if (Utils.isNullOrUndefined(route.params[PatientRouteParamsEnum.PATIENT_ID])) {
      throw new Error('Missing patient id');
    }
    return this._patientRestApiService.requestPatient(route.params[PatientRouteParamsEnum.PATIENT_ID] as string).pipe(
      tap((data: ApiPatientResponse) => this._patientDataParserService.parsePatientResponse(data)),
      mergeMap((data: ApiPatientResponse) => this._patientRestApiService.requestFile(data.pressureFileId ?? '')),
      mergeMap((data: ApiFileResponse) => this._patientDataParserService.parseFileResponse(data)),
      mergeMap((data: PatientData) => this._patientRestApiService.requestAlgoResults(data.algoResultsId)),
      map((response: ApiAlgoResultsResponse) => this._patientDataParserService.parseAlgoResultsResponse(response)),
    );
  }
}
